import { gql, useQuery } from '@apollo/client';
import { useEffect } from 'react';

import { BugTracker } from 'kb-shared/utilities/bugTracker';

import { PartnerInvite } from '../InterstitialModal.types';

const PARTNER_INVITES_QUERY = gql`
  query partnerInvites {
    partnerInvites {
      id
      firstName
      lastName
      email
      birthDate
      status
    }
  }
`;

export const usePartnerInvites = () => {
  const { data, loading, error, refetch } = useQuery(PARTNER_INVITES_QUERY);
  const allInvites: PartnerInvite[] = data ? data.partnerInvites : [];

  useEffect(() => {
    if (!error) return;

    BugTracker.notify(error, 'Failed to fetch partner invites');
  }, [error]);

  return {
    invites: allInvites,
    refetch,
    loading,
    error
  };
};
